import z from "zod";
import { SUPPORTED_CONNECTOR_PROTOCOL_VERSION } from "./protocol.js";
export const ConnectorKeyAlgorithmSchema = z.enum(["ed25519", "ecdsa-p256"]);
export const ConnectorProvisioningExchangeRequestSchema = z.object({
    protocolVersion: z.literal(SUPPORTED_CONNECTOR_PROTOCOL_VERSION),
    provisioningToken: z.string().min(1),
    publicKey: z.string().min(1),
    keyAlgorithm: ConnectorKeyAlgorithmSchema,
    connectorVersion: z.string().min(1),
});
export const ConnectorProvisioningExchangeResponseSchema = z.object({
    protocolVersion: z.literal(SUPPORTED_CONNECTOR_PROTOCOL_VERSION),
    connectorId: z.string().uuid(),
    workspaceId: z.string().uuid(),
    credentialFingerprint: z.string().min(1),
});
//# sourceMappingURL=provisioning.schema.js.map